export const SAVED_ARTEFACT_EXIT_TRANSITION_DURATION = 800; // 800 milliseconds
